<template>
  <div class="markup">
    <div class="markup__subtitle markup__subtitle_head">ТТ брендированная кнопка</div>

    <router-link to="/desktop/inReadVideoCustombutton" target="_blank" class="link">Пример брендированной кнопки</router-link>
    <br><br>
    <div class="attention attention_info">
      <div class="attention__title">Обратите внимание!</div>
      <ul class="markup__ul markup__ul_nested">
        <li>Размер кнопки адаптируется под размер плеера – данная адаптация будет реализована на нашей стороне. Таким образом максимальная ширина кнопки не будет превышать 200px или 1/3 ширины плеера, в зависимости от размера последнего.</li>
        <li>Доступна возможность выбирать расположение кнопки внутри плеера, чтобы она не перекрывала важные сообщения в видео (юридическую информацию, текст, логотип и проч.).</li>
        <li>Помимо этого, у нас есть 2 варианта активации кнопки в плеере:
          <ul class="markup__ul markup__ul_nested">
            <li>кнопка появляется сразу при запуске ролика и "висит" статично.</li>
            <li>кнопка появляется при наведении курсора на ролик.</li>
          </ul>
        </li>
      </ul>
    </div>

    <br>
    <div class="markup__h markup__h_3">
      <strong>Необходимые материалы и ограничения:</strong>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>Количество символов: рекомендуется не превышать 25-30</li>
      <li>Формат материалов для брендирования кнопки:  PNG / JPG / PSD / FIGMA / AI</li>
      <li>Размеры: ширина картинки кнопки должна быть не менее 400px </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'brandButton',
  components: {},
  data() {
    return {};
  },
};
</script>

<style scoped lang='stylus'>
@import '../../../styles/main.styl'
@import '../../../styles/documentation_article_markup.styl'

</style>
